// removed by extract-text-webpack-plugin
module.exports = {"root":"StoryBody__root--2VihO","hidden":"StoryBody__hidden--284qb","list":"StoryBody__list--OGO1x","paragraph":"StoryBody__paragraph--2-Doz","bold":"StoryBody__bold--30gsO","caption":"StoryBody__caption--z-cgi","subhead":"StoryBody__subhead--3hgz5","link":"StoryBody__link--10w8x","bounce":"StoryBody__bounce--1aTcv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/StoryBody/StoryBody.css
// module id = ./src/components/Library/StoryBody/StoryBody.css
// module chunks = 1